// 获取易班的code
export default () => {
  let Appid = '30322b0f1bcee0c7'
  let dfUrl = encodeURIComponent(`http://f.yiban.cn/iapp661503`)

  let windowHref = window.location.href
  localStorage.setItem('windowHref', windowHref)
  location.href = `https://oauth.yiban.cn/code/html?client_id=${Appid}&redirect_uri=${dfUrl}&state=STATE`
}



// WEBPACK FOOTER //
// ./src/assets/js/yiBanAuth.js